import React from 'react';
import PropTypes from 'prop-types';

import { titleCase } from '../../../../../utils/formatting';
import RatingTrend from '../../../SubRating/ratingTrendV2';
import Img from '../../../../Img';

import styles from '../../index.module.scss';

const RankedPlayerItem = ({
    displayName,
    firstName,
    lastName,
    rating,
    ranking,
    gender,
    nationality,
    threeMonthRatingChangeDetails,
    loading,
}) => {
    return (
        <div className={`${styles.rankItem}`} data-test="rank-item">
            {!loading ? (
                <div className={`row ${styles.playerRow}`}>
                    <div
                        className={`col-1 ${styles.rankItemColumn} ${styles.rankColumn}`}
                        data-test="ranking"
                    >
                        {ranking?.toString().padStart(2, '0')}
                    </div>
                    <div
                        className={`col-5 col-sm-5 ${styles.rankItemColumn} jcfs`}
                    >
                        <div className={styles.name} data-test="name">
                            <span className="d-none d-md-flex">
                                {titleCase(displayName)}
                            </span>
                            <span className={`d-flex d-md-none ${styles.mobilePlayers}`}>
                                {`${firstName.charAt(0)}. ${titleCase(lastName)}`}
                            </span>
                        </div>
                    </div>
                    <div className={`col-6 ${styles.rankItemColumn}`}>
                        <div className={`row flex-grow`}>
                            <div
                                className={`d-none d-md-flex col-md-3 ${styles.rankItemColumn}`}
                                data-test="gender"
                            >
                                {gender && gender[0]}
                            </div>
                            <div
                                className={`d-none d-md-flex col-md-3 ${styles.rankItemColumn}`}
                                data-test="nationality"
                            >
                                {nationality}
                            </div>
                            <div
                                className={`col-6 col-md-3 text-nowrap ${styles.rankItemColumn}`}
                            >
                                {threeMonthRatingChangeDetails && (
                                    <RatingTrend
                                        {...threeMonthRatingChangeDetails}
                                    />
                                )}
                            </div>
                            <div
                                className={`col-6 col-md-3 ${styles.rankItemColumn}`}
                                data-test="rating"
                            >
                                <div className={styles.name}>
                                    {rating?.toFixed(2)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div
                    className={`row ${styles.playerRow}`}
                    data-test="loader"
                >
                    <div className={`col-12 ${styles.rankItemColumn} jcc`}>
                        <div className={styles.loading}>
                            <Img
                                src="/img/loading/ranked-player-loader.gif"
                                alt="loading"
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

RankedPlayerItem.propTypes = {
    rating: PropTypes.number,
    ranking: PropTypes.number,
    displayName: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    nationality: PropTypes.string,
    loading: PropTypes.bool,
};

RankedPlayerItem.defaultProps = {
    displayName: '',
    firstName: '',
    lastName: '',
    nationality: '',
    loading: false,
    rating: null,
    ranking: null,
};

export default RankedPlayerItem;
